const notificationAR = {
  notification_NewMessageTemplate: 'تم إستلام رسالة جديدة',
  notification_UserLockedTemplate: 'تم تعطيل المستخدم',
  notification_OrderPlacedTemplate: 'تم تقديم طلب: لقد تلقيت طلبًا من #{userName}',
  notification_OrderUpdatedTemplate: 'تم تحديث طلب',
  notification_OrderCancelledTemplate: 'تم إلغاء طلب',
  notification_InvoiceIssuedTemplate: 'تم إصدار إيصال',
  notification_InvoicePaidTemplate: 'تم دفع الإيصال',
  notification_InvoiceFailedTemplate: 'فشل دفع الإيصال',
  notification_ProposalRequestedTemplate: 'تم طلب عرض سعر: لقد تلقيت طلب عرض سعر من المستخدم #{userName}.',
  notification_ProposalUpdatedTemplate: 'تم تحديث طلب السعر: تم إلغاء طلب السعر رقم # #{quoteNumber} من المستخدم #{userName}.',
  notification_ProposalAcceptedTemplate: 'تم قبول عرض سعر: تم قبول طلب السعر رقم # #{quoteNumber} من المستخدم #{userName}.',
  notification_CartItemUpdatedTemplate: 'تم تحديث عنصر في سلة التسوق.',

  orderCancelledByAdminNotification: 'الطلب رقم #{orderNumber}: تم إلغاءه بسبب مشكلة. يُرجى مراجعتها وإعلام العميل.',
  orderCancelledByUserNotification: 'الطلب رقم #{orderNumber}: تم إلغاءه بواسطة العميل.',
  orderPaidNotification: 'الطلب رقم #{orderNumber}: تم استلام الدفع لهذا الطلب.',
  orderDeliveredNotification: 'الطلب رقم #{orderNumber}: تم التسليم بنجاح للعميل.',
};

export default notificationAR;
